import { PowerBIReportDescription } from '../../lib/api/types/PowerBIReportDescription';
import { createReducer } from 'typesafe-actions';
import { PowerBiActions } from '../actions/powerBi';
import { GetEmbedInfoForReportResponse } from '../../lib/api/types/GetEmbedInfoForReportResponse';

interface PowerBiState {
    reports: PowerBIReportDescription[];
    currentReport?: PowerBIReportDescription;
    currentReportEmbedInfo?: GetEmbedInfoForReportResponse;
    reportLoaded: boolean;
}

const defaultState: PowerBiState = {
    reports: [],
    reportLoaded: false,
};

export const powerBiReducer = createReducer<PowerBiState, PowerBiActions>(defaultState)
    .handleAction(PowerBiActions.reportDescriptionsReceived, (state, { payload }) => ({ ...state, reports: payload }))
    .handleAction(PowerBiActions.viewReport, (state, { payload }) => ({
        ...state,
        currentReport: payload,
        currentReportEmbedInfo: undefined,
        reportLoaded: false,
    }))
    .handleAction(PowerBiActions.closeReport, (state) => ({
        ...state,
        currentReport: undefined,
        currentReportEmbedInfo: undefined,
    }))
    .handleAction(PowerBiActions.embedInfoReceived, (state, { payload }) => ({
        ...state,
        currentReportEmbedInfo: payload,
    }))
    .handleAction(PowerBiActions.reportLoaded, (state) => ({ ...state, reportLoaded: true }));
